import { useEffect, useState } from 'react';

export const MakeDateString = (date: string): string =>
  date.split(' ')[0].replaceAll('-', '.');

export default function useMakeDateString(date: string): string {
  const [dateString, setDateString] = useState('');

  useEffect(() => {
    setDateString(MakeDateString(date));
  }, [date]);

  return dateString;
}
